import { Dayjs } from "dayjs";
import { ExperiencePurchaseItem } from "./ExperiencePurchaseItem";
import { PurchaseItemObject } from "./PurchaseItemObject";

export interface AbandonedPurchaseItem extends ExperiencePurchaseItem {
    audits: AbandonedItemAudit[];
}

export interface AbandonedItemAudit {
    id: ID;
    createdAt: Dayjs;
    data: { [key: string]: { old: any; new: any } };
    objectClass: PurchaseItemObject;
    objectId: ID;
    seller: { id: ID };
}

export enum AbandonItemStatus {
    ABANDONED = "abandoned",
    CONVERTED = "converted",
    EMAILED = "emailed",
    AUTO_EMAILED = "autoemailed",
    DELETED = "deleted",
}
